/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { Button } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers';
import { RoutesName } from '../../states/constants';
import { ModalDecline } from './ModalDecline';
import {
  ModalTermsContent,
  ModalTermsStyles,
  ButtonsContainer,
  ButtonLink,
} from './Styles';
import { TermsCondition } from './TermsCondition';

export const ModalRgpd = ({
  switchModal,
  rgpdRead,
  changeRgpdRead,
}: {
  switchModal: any;
  rgpdRead: boolean;
  changeRgpdRead: any;
}) => {
  const [bottom, setBottom] = useState<boolean>(false);
  const { t } = useTranslation();
  const { logout, acceptTerms } = useAuth();
  const navigate = useNavigate();
  const [showDeclineModal, setShowDeclineModal] = useState<boolean>(false);

  const handleDeclineTerms = () => {
    setShowDeclineModal(true);
  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    if (
      Math.round(
        event.currentTarget.scrollHeight - event.currentTarget.scrollTop
      ) -
        100 <=
      event.currentTarget.clientHeight
    ) {
      setBottom(true);
      changeRgpdRead(true);
    }
  };

  const handleAcceptTerms = () => {
    acceptTerms();
    navigate(RoutesName.userInfo);
  };

  useEffect(() => {
    if (rgpdRead) {
      setBottom(true);
      const objElement = document.getElementById('contentView');
      (objElement as HTMLDivElement).scrollTop =
        objElement?.scrollHeight as number;
    }
  }, []);

  return (
    <ModalTermsStyles flexDirection="column" rowGap="1">
      <ModalTermsContent
        onScroll={handleScroll}
        data-test="rgpd"
        id="contentView"
      >
        <TermsCondition keyValue="rgpd" />{' '}
        <ButtonLink
          size="S"
          variant="text"
          onClick={() => switchModal(true)}
          testId="go-terms"
          color="secondary"
        >
          {t('Terms and conditions')}
        </ButtonLink>
      </ModalTermsContent>
      <ButtonsContainer columnGap="1.6" justifyContent="flex-end">
        <Button
          variant="text"
          color="error"
          size="L"
          testId="decline-terms"
          onClick={handleDeclineTerms}
        >
          {t('Decline').toLocaleUpperCase()}
        </Button>
        <Button
          size="L"
          disabled={!bottom}
          onClick={handleAcceptTerms}
          testId="accept-terms"
          color="secondary"
        >
          {t('Accept').toLocaleUpperCase()}
        </Button>
      </ButtonsContainer>

      <ModalDecline
        show={showDeclineModal}
        onChangeShow={(showModal) => setShowDeclineModal(showModal)}
        onDecline={logout}
      />
    </ModalTermsStyles>
  );
};
